import { AxiosInstance } from "axios";
import * as FileSaver from "file-saver";

export default (api: AxiosInstance, url: string) => async () => {
  const response = await api.post(url, null, {
    responseType: "blob",
  });
  const header = response.headers["content-disposition"];
  const filename = header.split("filename=")[1];
  FileSaver.saveAs(response.data, filename);
};



// WEBPACK FOOTER //
// ./src/services/api/admin/items/export.ts